import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import ITLobbyData from 'app/Models/Content/ITLobbyData';
import React from 'react';

export default class ITLobby extends Page<ITLobbyData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='ITLobby'>
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
